import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  OpenItemDto,
  OpenItemFilterDto,
  AgeingReportDto,
  AgeingFilterDto,
  OutstandingInquiryDto,
} from '@/types/openItem.types';

export const openItemApi = {
  /** GET /api/v1/open-items — paged open item list */
  getList: (filter?: OpenItemFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<OpenItemDto>>>('/open-items', { params: filter }),

  /** GET /api/v1/open-items/by-party — all open items for a specific party (for allocation screen) */
  getByParty: (params: {
    partyType:    string;
    partyId:      string;
    currencyCode?: string;
    locationId?:   string;
    costCenterId?: string;
  }) =>
    apiClient.get<ApiResponse<OpenItemDto[]>>('/open-items/by-party', { params }),

  /** GET /api/v1/open-items/ageing — ageing analysis (bands from the resolved profile, GAP-011) */
  getAgeing: (filter: AgeingFilterDto) =>
    apiClient.get<ApiResponse<AgeingReportDto>>('/open-items/ageing', { params: filter }),

  /** GET /api/v1/open-items/outstanding-summary — outstanding by party */
  getOutstandingSummary: (params: {
    partyType:         string;
    locationId?:       string;
    costCenterId?:     string;
    fyCode?:           string;
  }) =>
    apiClient.get<ApiResponse<OutstandingInquiryDto[]>>('/open-items/outstanding-summary', { params }),
};
